<template>
  <div class="history">
    <!-- <p class="font-red">
			每个文件下载后，将为您保存72小时，点击
			<span class="donwload-btn">下载</span> 即可重新下载
		</p>
		<el-tabs v-model="currentValue" class="tabs-list download-history-tabs">
			<el-tab-pane
				v-for="(o, oIndex) in tabList"
				:key="oIndex"
				:label="o.label"
				:name="o.name"
				class="tabs-content"
				v-loading="tableLoading"
			>
				<Table
					:obj="o.data"
					@sizeChange="sizeChange"
					@pageChange="pageChange"
				/>
			</el-tab-pane>
		</el-tabs> -->
    <TabTitle title="代下素材" />
    <div class="table-container">
      <Table
        :obj="tabList[0].data"
        @sizeChange="sizeChange"
        @pageChange="pageChange"
      />
    </div>
  </div>
</template>

<script>
import Table from "./module/table.vue";
import { getConsumeList } from "../../api/order";
import { previewImage } from "../../api/downLoad";
import TabTitle from "@/components/TabTitle.vue";
import {
  setToken,
  getTempUser,
  getToken,
  getNewUser,
} from "../../utils/storage";
export default {
  components: {
    Table,
    TabTitle,
  },
  data() {
    return {
      currentValue: "first",
      tabList: [
        {
          label: "代下素材",
          name: "first",
          data: {},
        },
      ],
      tableLoading: false,
      pageNo: 1,
      pageSize: 10,
    };
  },
  mounted() {
    this.getTableDatas();
    // if (getNewUser() == 0) {
    //   this.$store.commit("updateShowBottum", true);
    //   this.$store.commit("updateShowPost", true);
    // }
  },
  methods: {
    getTableDatas() {
      this.tableLoading = true;
      this.tabList.forEach((item, index) => {
        let dataform = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          orderType: index + 1,
        };
        getConsumeList(dataform)
          .then((result) => {
            this.tableLoading = false;
            result.datalists.forEach((item1) => {
              if (item1.source == 1) {
                if (item1.icon.indexOf("img.pptuku.com") > -1) {
                  item1.tempUrl = item1.icon.replace(
                    "img.pptuku.com",
                    "img.tukuwu.com"
                  );
                } else if (item1.icon.indexOf("img.taogetu.com") > -1) {
                  item1.tempUrl = item1.icon.replace(
                    "img.taogetu.com",
                    "img.tukuwu.com"
                  );
                } else {
                  item1.tempUrl = item1.icon.replace(
                    "img.taogetu.com",
                    "img.tukuwu.com"
                  );
                }
                item1.icon =
                  "https://img.aatuku.com/preview260/" +
                  item1.recCode +
                  ".jpg";
              }
            });
            item.data = result;
          })
          .catch((error) => {
            this.tableLoading = false;
          });
      });
    },
    pageChange(params) {
      this.pageNo = params;
      this.getTableDatas();
    },
    sizeChange(param) {
      this.pageSize = param;
      this.pageNo = 1;
      this.getTableDatas();
    },
  },
};
</script>

<style lang="scss" scoped>
.font-red {
  color: #909399;
  // float: right;
  // margin-top: 12px;
}

.el-tabs--card.download-history-tabs {
  > .el-tabs__header,
  > .el-tabs__header .el-tabs__item,
  > .el-tabs__header .el-tabs__nav {
    border: none;
  }
}

.table-container {
  background-color: white;
  padding: 30px;
}
</style>
